module.exports = __webpack_public_path__ + "media/images/flags/4x3/myt-352d34ed78c0883f1e5911633cd6f774.svg";